var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-favorite-player-select-pane"},[_c('player-select-list-section',{attrs:{"listData":_vm.players,"selectedID":_vm.selectedID},on:{"selectChange":_vm.changeSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }